// Optional scan/checkout sounds via Web Audio (no asset files required)
let audioContext: AudioContext | null = null
let soundsEnabled = true

export function setSoundsEnabled(enabled: boolean): void {
  soundsEnabled = enabled
}

export function getSoundsEnabled(): boolean {
  return soundsEnabled
}

function getContext(): AudioContext {
  if (!audioContext) audioContext = new (window.AudioContext || (window as unknown as { webkitAudioContext: typeof AudioContext }).webkitAudioContext)()
  return audioContext
}

function beep(freq: number, duration: number, type: OscillatorType = 'sine'): void {
  if (!soundsEnabled) return
  try {
    const ctx = getContext()
    const osc = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.connect(gain)
    gain.connect(ctx.destination)
    osc.frequency.value = freq
    osc.type = type
    gain.gain.setValueAtTime(0.15, ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.01, ctx.currentTime + duration)
    osc.start(ctx.currentTime)
    osc.stop(ctx.currentTime + duration)
  } catch {
    // ignore
  }
}

export function playScanSound(): void {
  beep(880, 0.08, 'sine')
  setTimeout(() => beep(1200, 0.06, 'sine'), 80)
}

export function playCheckoutSound(): void {
  beep(523, 0.1, 'sine')
  setTimeout(() => beep(659, 0.1, 'sine'), 100)
  setTimeout(() => beep(784, 0.15, 'sine'), 200)
}
